import { Helmet } from "react-helmet-async";

type Props = {
  schema: string | null | undefined;
};

export default function SchemaMarkup({ schema }: Props) {
  if (!schema?.trim()) return null;

  // Validate it's valid JSON before injecting
  try {
    JSON.parse(schema);
  } catch {
    return null;
  }

  return (
    <Helmet>
      <script type="application/ld+json">{schema}</script>
    </Helmet>
  );
}
